export const DocumentWrapper = document;
// TODO UI-2783: This is deprecated. Remove this and use getWindow() everywhere instead.
export const WindowWrapper = window;
export const getWindow = () => window;
export const getLocation = () => WindowWrapper.location;
export const setHref = (href: string) => {
  WindowWrapper.location.href = href;
};
